<template>
    <div :class="{header: true, test:$route.name === 'test' && attemp && test}">

        <div class="logo-menu-button">
            <div class="logo" @click="goHome()" style="cursor: pointer;">
                <img src="../../assets/logo_oniad_academy/ONiAd-Academy-logotipo.png" alt="Logotipo ONiAd Academy" >
            </div>
            <div class="menu-button" v-if="routesBtnCertificate.includes($route.name)">
                <div :class="{navIcon:true, active: isMenuOpen }" @click="toggleMenuBar">
                    <span class="iconbar1"></span>
                    <span class="iconbar2"></span>
                    <span class="iconbar3"></span>
                </div>
                <!--       <div class="menu-text">Menu</div> -->
                <!--       <button id="asdf">boton</button> -->
            </div>
        </div>
        <div class="btn-certificate" v-if="routesBtnCertificate.includes($route.name)">
            <button class="btn btn-success btn-lg" @click="$router.push({name:'certificateRequest',params:{id:$route.params.id}})">Obtén el certificado</button>
        </div>
        <div class="counter-test" v-if="$route.name === 'test' && attemp && test">
            <!--            <router-link to="/certificateRequest">Go to Foo</router-link>-->
            <div>
<!--                <countdown :time="60*1000">-->
<!--                    <template slot-scope="props">Time Remaining：{{ props.days }} days, {{ props.hours }} hours, {{ props.minutes }} minutes, {{ props.seconds }} seconds.</template>-->
<!--                </countdown>-->
                <countdown :time="timeCountDown" :transform="transform" ref="countdown" v-on:end="counterEnd()" @progress="handleCountdownProgress">
                    <template slot-scope="props">{{ props.minutes }}:{{ props.seconds }}</template>
                </countdown>
            </div>
        </div>
            <div v-show="$route.name === 'test'" v-bind:style="`transition: width ${timeCountDown/1000}s linear;`" :class="{countBackground:true,start:styleWidth}"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'


    export default {
        name: "headerContent",
        computed: {
            timeCountDown(){
                if (this.test){
                    return 60*1000*this.test.attemp_time_limit_minutes;
                }
                return null;
                // return 10*1000*1;
            },
            ...mapState(['isMenuOpen','menuHasContent','test','testEnd','attemp'])
        },
        data(){
            return{
                routesBtnCertificate:['course','temary'],
                counter: null,
                window: {
                    width: 0,
                    height: 0
                },
                countBarWidth: 0,
                styleWidth: false
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods:{
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            counterEnd(){
                this.$store.commit({type: 'endTest',ended: true});
            },
            goHome(){
                // if (!this.$route.name === 'home'){
                    this.$router.push({name:'home'})
                // }
            },
            toggleMenuBar(){

                this.$store.dispatch({type: 'toggleMenu'});
            },
            transform(props) {
                Object.entries(props).forEach(([key, value]) => {
                    // Adds leading zero
                    const digits = value < 10 ? `0${value}` : value;

                    // uses singular form when the value is less than 2
                    // const word = value < 2 ? key.replace(/s$/, '') : key;

                    props[key] = `${digits}`;
                });

                return props;
            },
            handleCountdownProgress() {
                if (!this.styleWidth)
                    this.styleWidth = true;


            },
        }
    }
</script>

<style lang="scss">
    .logo{
        img{
            max-width: 150px;
        }
    }
.counter-test{
    font-size: 2em;
}
.countBackground{
    display: none;
   position: absolute;
    height: 80px;
    top: 0;
    left: 0;
    width: 0;
    background-image: linear-gradient(45deg, rgba(50, 197, 210, 1) 1%, rgba(50, 197, 210, 0.5) 80%), linear-gradient(-45deg, #ff1b00 40%, rgba(50, 197, 210, 0.7) 80%);
    z-index: -1;
    &.start{
        width: 100% !important;
    }
}
</style>